import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextareaAutosize,
} from "@mui/material";
import { Input } from "@100mslive/roomkit-react";
import FullPageProgress from "../FullPageProgress";
import { ToastManager } from "../Toast/ToastManager";
import { SESSION_AUTH } from "../../common/auth";
import { OTHER_SERVICES } from "../../services";

const CompanyReportModal = props => {
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const { accountId, orgName, open, onClose } = props;
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessgae] = useState("");

  useEffect(() => {
    if (isUserSession) {
      setName(isUserSession?.name);
    } else {
      onClose();
    }
  }, [isUserSession, onClose]);

  const onSend = async () => {
    if (!name?.trim()) {
      ToastManager.addToast({
        title: "Please enter your name",
      });
      return false;
    } else if (!message?.trim()) {
      ToastManager.addToast({
        title: "Please enter your message",
      });
      return false;
    }

    setLoading(true);

    OTHER_SERVICES.companyReportIssue({
      userId: isUserSession.userId,
      org: isUserSession?.org?.id,
      name: name?.trim(),
      email: isUserSession?.email,
      phone: phone,
      message: message,
      company: orgName,
      url: window.location.href,
      id: accountId,
    })
      .then(data => {
        setLoading(false);
        if (data.code === 200) {
          ToastManager.addToast({
            title: data.message,
          });
          onClose();
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data?.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err?.message });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="custom-dialog"
      >
        {loading && <FullPageProgress fixed={true} />}

        <DialogTitle className="text-center">
          Report issue <br /> <small className="text-primary"> {orgName}</small>
        </DialogTitle>
        <DialogContent>
          <FormControl className="custom-form-group">
            <label
              htmlFor="company-report-name"
              className="custom-form-label big-label"
            >
              Name
            </label>
            <Input
              id="company-report-name"
              name="name"
              placeholder=" Your name"
              className="custom-form-input"
              value={name}
              onChange={e =>
                setName(e.target?.value?.replace(/(<([^>]+)>)/gi, ""))
              }
              autoComplete="none"
            />
          </FormControl>

          <FormControl className="custom-form-group">
            <label
              htmlFor="company-report-phone"
              className="custom-form-label big-label"
            >
              Phone (Optional)
            </label>
            <Input
              id="company-report-phone"
              name="phone"
              placeholder="Your phone number"
              className="custom-form-input"
              value={phone}
              onChange={e =>
                setPhone(e.target?.value?.replace(/(<([^>]+)>)/gi, ""))
              }
              autoComplete="none"
              type="tel"
            />
          </FormControl>

          <FormControl className="custom-form-group">
            <label
              htmlFor="company-report-issue-msg"
              className="custom-form-label big-label"
            >
              Message
            </label>
            <TextareaAutosize
              id="company-report-issue-msg"
              name="message"
              value={message}
              onChange={e =>
                setMessgae(e.target?.value?.replace(/(<([^>]+)>)/gi, ""))
              }
              className="custom-form-input"
              placeholder="Your message"
              minRows={4}
              maxRows={4}
            />
          </FormControl>
        </DialogContent>
        <DialogActions className="custom-dialog-action">
          <Button
            onClick={onClose}
            variant="outlined"
            color="secondary"
            className="events6ix-btn events6ix-btn-light"
            type="button"
          >
            Cancel
          </Button>

          <Button
            onClick={onSend}
            variant="outlined"
            color="primary"
            className="events6ix-btn events6ix-btn-primary"
            type="button"
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default CompanyReportModal;
